// Notifications display for the home page

import React from 'react';
import { bool, string, object, func, array, oneOfType } from 'prop-types';
import { isEmpty } from 'ramda';

import LoadingState from '../LoadingState';
import withNotificationBuilder from './withNotificationBuilder';

import s from './Notifications.css';


const Notifications = ({ data = [], isLoading, header, renderNotifications, types }) => {

  if (isLoading) {
    return (
      <div className={s.message}>
        <p>
          Loading your Notifications...
        </p>
        <LoadingState context="notifications" />
      </div>
    );
  } else if (data) {
    return (
      <section className={s.component}>
        <h3 className={s.header}>
          {header}
        </h3>
        {renderNotifications(data)}
      </section>
    );
  } else if (isEmpty(data)) {
    return (
      <section className={s.component}>
        <p className={s.message}>
          There was an error retrieving Notifications
        </p>
      </section>
    );
  } else {
    return (
      <section className={s.component}>
        <h3 className={s.header}>
          My Notifications
        </h3>
        <p className={s.message}>
          You have no new notifications.
        </p>
      </section>
    );
  }

};

/**
* @props
* loadingNotifications = pending/rejected status passed from RootContainer where api call is made
* renderNotifications = renders the html from passed data in withNotificationBuilder
* types = static strings of what this component is displaying
* data = the response object we want to renderNotifications
*/
Notifications.propTypes = {
  header: string,
  isLoading: bool,
  renderNotifications: func,
  types: string,
  data: oneOfType([
    array,
    object
  ]),
};

export default withNotificationBuilder()(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js